import { NgModule } from '@angular/core';
import { CartAccessCodeConnector, CartEventModule, CartGuestUserConnector, CartPageEventModule, CartPersistenceModule, CartValidationConnector, CartVoucherConnector } from '@spartacus/cart/base/core';
import { GenMultiCartStoreModule } from './store/multi-cart-store.module';
import { GenCartConnector } from './connectors/cart/cart.connector';
import { GenCartEntryConnector } from './connectors/entry/cart-entry.connector';
import { HttpErrorHandler } from '@spartacus/core';
import { BadCartRequestHandler } from './http-interceptors/handlers/bad-cart-request.handler';
import { BadVoucherRequestHandler } from './http-interceptors/handlers/bad-voucher-request.handler';


@NgModule({
  imports: [
    CartEventModule,
    CartPersistenceModule,
    CartPageEventModule,
    GenMultiCartStoreModule,
  ],
  providers: [
    GenCartConnector,
    GenCartEntryConnector,
    CartVoucherConnector,
    CartValidationConnector,
    CartAccessCodeConnector,
    CartGuestUserConnector,
    {
      provide: HttpErrorHandler,
      useExisting: BadCartRequestHandler,
      multi: true,
    },
    {
      provide: HttpErrorHandler,
      useExisting: BadVoucherRequestHandler,
      multi: true,
    },
  ],
})
export class GenCartBaseCoreModule { }
